interface SpinnerProps {
  title: string;
  subtitle?: string;
}

export function Spinner({ title, subtitle }: SpinnerProps): React.JSX.Element {
  return (
    <div className="tbo-spinner">
      <div className="tbo-spinner-ring" aria-hidden="true" />
      <p className="tbo-spinner-title">{title}</p>
      {subtitle && <p className="tbo-spinner-sub">{subtitle}</p>}
    </div>
  );
}
